import $ from 'jquery'
import { eventTracker, semEventTracker } from '../../../common/tracker'

export const qqModule = function (type) {
	$(document).on('ready', function () {
		$(".qq-title").on('click', function () {
			$(".customer-box").hide();
			$(".customer-hide").show();
		})
		$(".customer-hide").on('click', function () {
			$(".customer-box").show();
			$(".customer-hide").hide();
		})

		//hoverQQ图标event打点
		$("#qq").on('mouseenter', () => {
			if (type === 'sem') {
				semEventTracker("qq-pc", "float-pc", "hover")
			} else {
				eventTracker("qq-pc", "float-pc", "hover")
			}
		})
		//hover电话打点
		$("#mobile").on('mouseenter', () => {
			if (type === 'sem') {
				semEventTracker("phone-pc", "float-pc", "hover")
			} else {
				eventTracker("phone-pc", "float-pc", "hover")
			}
		})
		//hover微信打点
		$("#wechat").on('mouseenter', () => {
			if (type === 'sem') {
				semEventTracker("wechat-pc", "float-pc", "hover")
			} else {
				eventTracker("wechat-pc", "float-pc", "hover")
			}
		})

		//点击QQ客服event打点
		$("#qq .qq-link").on('click', () => {
			if (type === 'sem') {
				semEventTracker("qq-click-pc", "float-pc")
			} else {
				eventTracker("qq-click-pc", "float-pc")
			}
		})

		//微信打点
		$("#wechat .click-copy").on('click', () => {
			if (type === 'sem') {
				semEventTracker("wechat-copy-pc", "float-pc")
			} else {
				eventTracker("wechat-copy-pc", "float-pc")
			}
		})

		//hover53图标event打点
		$("#kf53").on('mouseenter', () => {
			if (type === 'sem') {
				semEventTracker("kf53-pc", "float-pc", "hover")
			} else {
				eventTracker("kf53-pc", "float-pc", "hover")
			}
		})
		
		//点击53客服event打点
		$("#kf53").on('click', () => {
			if (type === 'sem') {
				semEventTracker("kf53-click-pc", "float-pc")
			} else {
				eventTracker("kf53-click-pc", "float-pc")
			}
			var width = 800; // 窗口宽度
			var height = 600; // 窗口高度
			// 计算窗口在屏幕上居中的位置
			var left = (window.innerWidth - width) / 2;
			var top = (window.innerHeight - height) / 2;
			var domainSlug = window.domainSlug;
			if (domainSlug) {
				window.open(`https://chato.cn/b/${domainSlug}?source=Chato_share_web&channel=${window.document.title || ''}`,
					'_blank',
					'width=' +
					width +
					',height=' +
					height +
					',left=' +
					left +
					',top=' +
					top,
				);
				return;
			}
			if (window.$53) {
				var api = $53.createApi();
				api.push('cmd', 'kfclient');
				api.push('type', 'new');
				api.query();
			} else {
				alert('请稍后再试！')
			}
		})
	})
}

const backToTop = $('#back-to-top');
const windowHeight = window.innerHeight || document.documentElement.clientHeight;

$(window).on('load', function() {
  // 当页面上的所有资源都加载完成后执行
  window.top ? window.top.postMessage(window.document.title, '*') : null;
});

$(document).scroll(() => {
	// @ts-ignore
	if ($(document).scrollTop() > windowHeight) {
		backToTop.slideDown();
	} else {
		backToTop.slideUp();
	}
});

backToTop.on('click', () => {
	document.body.scrollIntoView({ block: 'start', behavior: 'smooth' });
});

const weChatCopyBtn = $('.service-modal__wechat .click-copy');
const baxFeedbackCopyBth = $('.service-modal__bax .click-copy');

weChatCopyBtn.on('click', () => {
	$('#wechat-id-textarea').select();
	document.execCommand('copy');
	weChatCopyBtn.text('复制成功！');
	setTimeout(() => {
		weChatCopyBtn.text('复制号码');
	}, 2000)
})

baxFeedbackCopyBth.on('click', () => {
    $('#wechat-id-textarea').select();
	document.execCommand('copy');
	weChatCopyBtn.text('复制成功！');
	setTimeout(() => {
		weChatCopyBtn.text('复制号码');
	}, 2000)
})

const entranceBtn = $('#entrance')
entranceBtn.on('click',()=>{
	const {position} = window.extraContactFormData
	const href = window.location.href
	const id = new RegExp("(?<=-)\\d.*(?=.html)").exec(href) ? new RegExp("(?<=-)\\d.*(?=.html)").exec(href)[0] : ''
	if(id){
		window.location.href = `safeguard?position=${position}&id=${+id}`
	}else{
		window.location.href = `safeguard?position=${position}`
	}
})


